export default {
  name: 'product_categories',

  translatedAttributes: [
    'name',
    'description',
  ],

  /**
   * Prepare item data for backend request
   * @param item
   * @returns Object
   */
  toArray: item => ({
    id: item.id,
    product_category_id: item.is_sub_category ? item.product_category_id : null,
    name_en: item.name.en,
    name_ar: item.name.ar,
    description_en: item.description.en,
    description_ar: item.description.ar,
    slug: item.slug,
    image: item.image,
    is_active: item.is_active,
  }),

  /**
   * Parse backend payload to item object
   * @param data
   * @param initialItemData
   * @returns Object
   */
  fromArray: (data, initialItemData = {}) => ({
    ...initialItemData,
    id: data.id,
    is_sub_category: !!data.product_category_id,
    product_category_id: data.product_category_id,
    name: {
      en: data.name_en,
      ar: data.name_ar,
    },
    description: {
      en: data.description_en,
      ar: data.description_ar,
    },
    slug: data.slug,
    image: data.image,
    is_active: !!data.is_active,
  }),

  resolveValidationErrors: errors => ({
    id: errors.id,
    name: {
      en: errors.name_en,
      ar: errors.name_ar,
    },
    description: {
      en: errors.description_en,
      ar: errors.description_ar,
    },
    slug: errors.slug,
    is_active: errors.is_active,
  }),
}
